import { types } from 'mobx-state-tree';

export default types.model('ShipmentTracking', {
  status: types.maybe(types.string),
  shipping_service: types.maybe(types.string),
  shipper: types.maybe(types.string),
  received_at: types.maybe(types.string),
  shipped_at: types.maybe(types.string),
  delivered_at: types.maybe(types.string),
  label_url: types.maybe(types.string),
  tracking_url: types.maybe(types.string),
  tracking_number: types.maybe(types.string),
  requires_label: types.maybe(types.boolean),
  shipment_direction: types.maybe(types.string),
  shipper_will_pickup: types.maybe(types.boolean),
  estimated_pickup: types.maybe(types.string),
  estimated_delivery: types.maybe(types.string),
  gokada_label_url: types.maybe(types.string),
});
